import { useAsyncFn } from 'react-use';
import {
  TransactionError,
  useAddress,
  useChainId,
  useContract
} from '@thirdweb-dev/react';
import { showErrorToast, showSuccessToast } from '@app/components/Toast';
import { ExternalLink } from '@app/components/ExternalLink';
import React from 'react';
import { queryClient } from '@app/context/AppContextWrapper';
import { QueryKeys } from '@app/constants/queryKeys';
import { useConfig } from '@app/config';
import { MetromUserReward } from '@app/hooks/metrom/useMetromUserRewards';
import { metromAbi } from '@metrom-xyz/contracts/abi';

export function useHarvestMetromRewards(
  data: MetromUserReward[] | null | undefined
) {
  const chainId = useChainId();
  const address = useAddress();
  const config = useConfig();

  const { contract } = useContract(config?.METROM.DISTRIBUTOR, metromAbi);

  const [{ loading }, harvestRewards] = useAsyncFn(async () => {
    if (!address || !chainId || !config || !data || !contract) {
      return;
    }

    const tx = contract.prepare('claimRewards', [
      data.map(claim => {
        return {
          campaignId: claim.campaignId,
          proof: claim.proof,
          token: claim.token.address,
          amount: claim.amount,
          receiver: address
        };
      })
    ]);

    try {
      const res = await tx.send();

      const receipt = await res.wait();

      if (receipt.transactionHash) {
        showSuccessToast(
          `Transaction successful`,
          <ExternalLink txHash={receipt.transactionHash} />
        );

        await queryClient.invalidateQueries([QueryKeys.METROM_CAMPAIGNS]);
        await queryClient.invalidateQueries({
          queryKey: [QueryKeys.METROM_USER_REWARDS]
        });
      }
    } catch (e) {
      console.error(e);

      if ((e as TransactionError).reason !== 'user rejected transaction') {
        showErrorToast(`Transaction failed`);
      }
    }
  }, [chainId, address, config, contract, data]);

  return {
    isLoading: loading,
    harvestRewards
  };
}
